/* VENA — hero slider. It is intentionally inactive when only one slide exists. */
(() => {
  'use strict';

  function initialiseHero(root) {
    if (!root || root.dataset.venaHeroReady === 'true') return;
    root.dataset.venaHeroReady = 'true';

    const count = Number(root.dataset.slideCount || 0);
    const track = root.querySelector('[data-vena-hero-track]');
    const dots = [...root.querySelectorAll('[data-vena-hero-dot]')];
    if (!track || count < 2) return;

    let activeIndex = 0;
    let timer;
    let startX = 0;
    let currentX = 0;
    const autoplay = root.dataset.autoplay === 'true';
    const delay = Number(root.dataset.autoplayDelay || 5000);

    function setSlide(index) {
      activeIndex = (index + count) % count;
      track.style.transform = `translateX(-${activeIndex * 100}%)`;
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function stopAutoplay() {
      window.clearInterval(timer);
      timer = undefined;
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplay || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = window.setInterval(() => setSlide(activeIndex + 1), delay);
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        setSlide(Number(dot.dataset.venaHeroDot));
        startAutoplay();
      });
    });

    track.addEventListener('pointerdown', (event) => {
      startX = event.clientX;
      currentX = event.clientX;
      stopAutoplay();
      track.setPointerCapture?.(event.pointerId);
    });

    track.addEventListener('pointermove', (event) => {
      currentX = event.clientX;
    });

    track.addEventListener('pointerup', () => {
      const change = currentX - startX;
      if (Math.abs(change) > 35) setSlide(activeIndex + (change < 0 ? 1 : -1));
      startAutoplay();
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });

    setSlide(0);
    startAutoplay();
  }

  function initialiseAll(scope = document) {
    if (scope.matches && scope.matches('[data-vena-hero]')) initialiseHero(scope);
    scope.querySelectorAll('[data-vena-hero]').forEach(initialiseHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(document), { once: true });
  } else {
    initialiseAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
